import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Service", href: "#services" },
  { label: "Team", href: "#team" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-pearl/85 backdrop-blur-md border-b border-charcoal/10"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="#home"
          data-testid="nav-logo"
          className="font-display text-2xl md:text-[1.7rem] leading-none text-charcoal"
        >
          {/*<She Means span className="italic text-lilac">Content</span>*/}
          <img src="/img/logo.png" alt="Logo"  style={{height:"60px"}}/>
        </a>

        <ul className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="nav-link"
                data-testid={`nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#contact"
          className="max-md:!hidden md:inline-flex btn-primary"
          data-testid="nav-cta-button"
        >
          Work With Us Now
        </a>

        <button
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          className="md:hidden text-charcoal p-2"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-[max-height,opacity] duration-500 ${
          open ? "max-h-[420px] opacity-100" : "max-h-0 opacity-0"
        } bg-pearl border-t border-charcoal/10`}
      >
        <ul className="px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                onClick={close}
                className="nav-link text-base"
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="#contact"
              onClick={close}
              className="btn-primary w-full justify-center"
              data-testid="nav-mobile-cta-button"
            >
              Work With Us
            </a>
          </li>
        </ul>
      </div>
    </header>
  );
}
